<template>
  <div class="mb-4">
    <button
      class="relative my-2 flex h-10 w-10 items-center justify-center rounded-full outline-none transition-all duration-200 focus:outline-none"
      :class="{
        'bg-green-100 hover:bg-green-200 hover:bg-opacity-80 dark:bg-green-800 dark:bg-opacity-50 dark:hover:bg-opacity-80':
          isNotificationPanelActive,
        'hover:bg-green-100 hover:dark:bg-green-800 hover:dark:bg-opacity-50':
          unreadCount,
        'text-gray-500 hover:bg-gray-100 hover:bg-opacity-80 dark:bg-opacity-50 dark:text-gray-400 hover:dark:bg-gray-700':
          !isNotificationPanelActive && !unreadCount,
      }"
      @click="openNotificationPanel"
    >
      <fluent-icon
        icon="alert"
        :class="{
          'text-green-500 dark:text-green-400':
            isNotificationPanelActive || unreadCount,
        }"
      />
      <span
        v-if="unreadCount"
        class="absolute -right-1 -top-0.5 h-4 w-4 animate-ping rounded-full bg-green-500 px-1 text-xxs duration-500 dark:bg-green-700"
      />
      <span
        v-if="unreadCount"
        class="absolute -right-1 -top-0.5 h-4 min-w-[1rem] rounded-full bg-green-500 px-1 text-xxs font-bold leading-4 text-white outline outline-white dark:bg-green-700 dark:bg-opacity-70 dark:outline-gray-800"
      >
        {{ unreadCount }}
      </span>
    </button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { updateFaviconBadge } from '../../../../shared/helpers/updateFaviconBadge';

export default {
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  watch: {
    unreadCount(newVal) {
      updateFaviconBadge(!!newVal);
    },
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('open-notification-panel');
      }
    },
  },
};
</script>
